import { useEffect, useRef } from "react";
import { ShipmentModel } from "features/shared/shipmentCard.types";
import { usePanelViews } from "features/shared/usePanelViews.hook";
import { appStore } from "entities/App/model/app.store";
import { isRoadSearchShipmentModel } from "entities/RoadSearchCard";
import { useAppDispatch, useAppSelector } from "shared/lib/redux";

import { getInitialSearchQPM } from "../ParamsManager";

type UseRoadUrlQueryHandlerProps = {
  openedCard: ShipmentModel | null;
};

export const useRoadUrlQueryHandler = ({ openedCard }: UseRoadUrlQueryHandlerProps) => {
  const dispatch = useAppDispatch();
  const openedCardQPM = useRef(getInitialSearchQPM()).current;
  const requestedFromUrl = useAppSelector(appStore.selectors.requestedFromUrl);
  const { isCurrentViewOpenedCard } = usePanelViews();

  useEffect(() => {
    if (!isCurrentViewOpenedCard) return;
    if (requestedFromUrl || !openedCard?.reference) return;

    openedCardQPM.set("number", openedCard.reference);

    if (isRoadSearchShipmentModel(openedCard)) {
      const carrier = openedCard?.scac;
      const type = openedCard?.type;

      if (carrier) {
        openedCardQPM.set("carrier", carrier);
      }
      if (type) {
        openedCardQPM.set("type", type);
      }
    }
    openedCardQPM.update();
  }, [openedCard?.rawData]);

  useEffect(
    () => () => {
      openedCardQPM.clear();
      openedCardQPM.update();
      dispatch(appStore.actions.setRequestedFromUrl(false));
    },
    []
  );
};
